var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-loader',{attrs:{"height":226,"width":750}},[_c('rect',{attrs:{"x":"0","y":"25","rx":"0","ry":"0","width":"180","height":"135"}}),_c('rect',{attrs:{"x":"217","y":"25","rx":"0","ry":"0","width":"550","height":"165"}})])}
var staticRenderFns = []

export { render, staticRenderFns }